import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import RelocationList from "./../pages/Residential/Optional/Relocation/RelocationList";
import {
    fetchRelocationForms,
    deleteRelocationForm,
} from "../store/slices/relocationFormsSlice";

const Relocations = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { relocationForms, isLoading, error } = useSelector(
        (state) => state.relocationForms
    );

    useEffect(() => {
        dispatch(fetchRelocationForms());
    }, [dispatch]);

    const handleAdd = () => navigate("/residential/optional/relocation-form/add");
    const handleEdit = (id) => navigate(`/residential/optional/relocation-form/edit/${id}`);
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this record?")) {
            dispatch(deleteRelocationForm(id));
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body p-0">
                        <RelocationList
                            records={relocationForms}
                            loading={isLoading}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                        {error && <p className="text-danger p-3">{error}</p>}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default Relocations;
